import { useNavigation } from "@repo/core/hooks/useNavigation";
import { useMemo, useState } from "react";

import { useQuery } from "@tanstack/react-query";
import { TransactionsResource } from "@repo/core/services/resources/transactions";
import { apiInstance } from "@repo/core/services/instances/api";
import {
  groupedTransactionStatus,
  GroupedTransactionStatusEnum
} from "@repo/core/constants/transactions";
import { groupTransactionsByDate } from "@repo/core/utils/transactions.utils";

const transactionsResource = new TransactionsResource(apiInstance);

export const TransactionsController = () => {
  const { back, params } = useNavigation();
  const [filterByStatus, setFilterByStatus] = useState<
    GroupedTransactionStatusEnum | "all"
  >(params?.transactionsStatus || "all");

  const { data: transactionsData, isLoading: transactionsIsLoading } = useQuery(
    {
      queryKey: ["findTransactions"],
      queryFn: () => transactionsResource.findTransactions()
    }
  );

  const transactions = useMemo(() => {
    if (!transactionsData?.data.length) {
      return [];
    }

    if (filterByStatus && filterByStatus !== "all") {
      const filteredTransactions = transactionsData?.data.filter(
        (transaction) => {
          const transactionsStatus = groupedTransactionStatus[filterByStatus];

          return transactionsStatus.includes(transaction.strSituacao)
        }
      );
      return groupTransactionsByDate(filteredTransactions);
    }

    return groupTransactionsByDate(transactionsData?.data);
  }, [transactionsData, filterByStatus]);

  const handleSelectStatus = (status: GroupedTransactionStatusEnum) => {
    setFilterByStatus(status);
  };

  return {
    back,
    transactions,
    handleSelectStatus,
    transactionsIsLoading,
    filterByStatus
  };
};
